"use strict";
exports.__esModule = true;
exports.cosSources = exports.SkillsSections = void 0;
var SkillsSections;
(function (SkillsSections) {
    SkillsSections["POSITIVE"] = "positiveSkills";
    SkillsSections["ACQUIRING"] = "acquiringSkills";
    SkillsSections["ACTIONS"] = "actionsSkills";
})(SkillsSections = exports.SkillsSections || (exports.SkillsSections = {}));
exports.cosSources = [
    'Assessment tool/interview',
    'Standardized norm referenced tool',
    'Child-care provider observation/report',
    'Family report',
    'Medical professional report',
    'Service provider observation/report',
];
//# sourceMappingURL=index.js.map